import React, { Component } from 'react';
import { submit, reset } from 'redux-form';
import { connect } from 'react-redux';
import { SectionBlock } from '../components';
import { AccountInformationForm } from '../forms';

class AccountInformation extends Component {
  state = {
    isEditable: false
  };

  toggleEdit = () =>
    this.setState(oldState => ({ isEditable: !oldState.isEditable }));

  onCancel = () => {
    const { resetForm } = this.props;
    resetForm();
    this.toggleEdit();
  };

  render() {
    const { initialValues, submitForm } = this.props;
    const { isEditable } = this.state;
    const InputProps = isEditable
      ? {}
      : { disableUnderline: true, disabled: true };
    const additionalInitialValues = {
      ...initialValues,
      role_placeholder:
        initialValues.role[0].toUpperCase() + initialValues.role.slice(1),
      password_placeholder: '*****************'
    };
    return (
      <SectionBlock
        title="Account Information"
        isEditable={isEditable}
        onCancel={this.onCancel}
        toggleEdit={this.toggleEdit}
        submit={submitForm}
      >
        <AccountInformationForm
          InputProps={InputProps}
          initialValues={additionalInitialValues}
          onSubmitSuccess={this.toggleEdit}
        />
      </SectionBlock>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  submitForm: () => dispatch(submit('accountInformationForm')),
  resetForm: () => dispatch(reset('accountInformationForm'))
});

export default connect(
  null,
  mapDispatchToProps
)(AccountInformation);
